<template>
    <div :class="classes">
        <carousel
            class="carousel"
            :per-page="1"
            :mouse-drag="false"
            paginationColor="#F2C0DE"
            paginationActiveColor="#F2C0DE"
            :paginationPadding="0"
            :paginationSize="5"
            :centerMode="true"
            @page-change="handlePageChange"
        >
            <slide
                v-for="(image, index) in images"
                :key="image.product_id"
                @slide-click="handleImgClick(image, index)"
            >
                <div class="slide product" v-if="featuredOutfit">
                    <img
                        ref="slideImage"
                        class="slide-image product"
                        :src="apiImageUrl(image.product_image_uri)"
                        :style="{ maxHeight: slideshowHeight }"
                    />
                </div>
                <div class="slide" v-else :class="{ product: product }">
                    <img
                        v-if="product"
                        ref="slideImage"
                        class="slide-image product"
                        :src="apiImageUrl(image)"
                        :style="{ maxHeight: slideshowHeight }"
                    />
                    <img
                        v-else
                        ref="slideImage"
                        class="slide-image"
                        :src="imageUrl(image)"
                        :style="{ maxHeight: slideshowHeight }"
                    />
                </div>
            </slide>
        </carousel>
        <slideshow-zoom
            ref="zoom"
            v-if="!featuredOutfit"
            v-show="showZoomModal"
            :images="zoomImages"
            :index="zoomIndex"
            :product="product"
        >
        </slideshow-zoom>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import SlideshowZoom from "./slideshow-zoom.vue";
import Mixins from "../../mixins/mixins.js";

export default {
    components: {
        Carousel,
        Slide,
        SlideshowZoom,
    },
    props: [
        "images",
        "zoomImages",
        "product",
        "slideshowHeight",
        "featuredOutfit",
        "classes",
        "products",
        "outfitId",
    ],
    mixins: [Mixins],
    data() {
        return {
            touchStartTime: null,
            showZoomModal: false,
            zoomIndex: 0,
        };
    },
    created() {
        this.$on("closeModal", () => {
            this.showZoomModal = false;
        });
    },
    methods: {
        handleImgClick(image, index) {
            if (document.body.className.includes("keyboard-opened")) return;

            if (this.featuredOutfit) {
                this.$helpers.visitProduct(this.$router, image, {
                    outfitId: this.outfitId,
                });
            } else {
                this.showZoomModal = true;
                this.zoomIndex = index;
                this.$refs.zoom.opened();
            }
            this.$emit("imageClicked");
        },
        handlePageChange(index) {
            this.$parent.$emit("productSwapIndex", index);
        },
    },
};
</script>
